export default __webpack_public_path__ + "static/media/om_logo.0b067ddb.svg";